import React, { useEffect } from 'react'
import NormalLayoutContainer from '../shared/NormalLayoutContainer'
import styles from './index.module.scss'
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import DriverComparison from '../../components/reports/DriverComparison'
import TicketHeatmap from '../../components/reports/ticket-heatmap'
import TicketOverview from '../../components/reports/TicketOverview'
import TicketDetails from '../../components/reports/ticket-details'
import cn from 'classnames'
import { Spinner } from '../shared/Spinner'
import QUERY_KEYS from '../../graphql/queryKeys'
import reportsQuery from '../../graphql/queries/reports'
import useQuery from '../../hooks/useQuery'
import { captureErrorAndNotify } from '../../utilities/errorHandlers'
import { SET_REPORTS } from './reducers/reportsReducer'
export default function ReportPage () {
  const { reports, hauler } = useSelector(({ reports: { reports }, user }) => ({
    reports,
    hauler: user.hauler
  }))

  const dispatch = useDispatch()

  const { id } = useParams()
  const report = reports?.find(report => report.id === id)

  const { data: { reports: { reports: reportData } }, isFetching: isReportsListFetching } = useQuery([
    QUERY_KEYS.reports,
    hauler.id
  ],
  reportsQuery,
  {
    enabled: reports?.length === 0,
    initialData: { reports: {} },
    onError: (error) => {
      captureErrorAndNotify(error, 'Failed to fetch reports data')
    }
  })

  useEffect(() => {
    if (reportData?.length > 0) {
      dispatch({ type: SET_REPORTS, payload: { reports: reportData, isFetching: false } })
    }
  }, [reportData, dispatch])

  return (
    <NormalLayoutContainer>
      <div className={styles.navigation}>
        <div className={styles.navigationLeft}>
          <Link to='/reports'>
            <i className={cn(styles.backIcon, 'material-icons')}>west</i>
          </Link>
          <h1 className={styles.reportTitle}>{report?.name}</h1>
        </div>
        <div className='btn-group'>
          <Link to='/reports' className={cn(styles.navigationButton, 'btn btn-sm btn-primary')}>
            Switch Reports
          </Link>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a className={cn(styles.navigationButton, 'btn btn-primary btn-sm dropdown-toggle hidden-xs hidden-sm drop-down')} data-toggle='dropdown'>
            <span className='caret' />
          </a>
          <ul className='dropdown-menu'>
            <li>
              {reports?.map(report => (
                <Link key={report.id} to={report.name === 'AR Dashboard' ? '/ar-dashboard' : `/reports/${report.id}`}>
                  {report.name}
                </Link>
              ))}
            </li>
          </ul>
        </div>
      </div>
      {/* Commented out code is used in PowerBI Implementation, so need to keep until the migration happens */}
      {/* {
        report &&
          <PowerBIEmbed
            embedConfig={{
              type: 'report',
              id,
              embedUrl: report.embedURL,
              accessToken: reportToken,
              tokenType: powerBI.models.TokenType.Embed,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false
                  }
                }
              }
            }}
            cssClassName={styles.report}
          />
      } */}
      {
        report && !isReportsListFetching && (
          <>
            { report?.name?.toLowerCase()?.replaceAll(' ', '_') === 'driver_comparison' && <DriverComparison /> }
            { report?.name?.toLowerCase()?.replaceAll(' ', '_') === 'ticket_overview' && <TicketOverview /> }
            { report?.name?.toLowerCase()?.replaceAll(' ', '_') === 'ticket_details' && <TicketDetails /> }
            { report?.name?.toLowerCase()?.replaceAll(' ', '_') === 'ticket_heatmap' && <TicketHeatmap /> }
          </>
        )
      }
      {
        isReportsListFetching && <Spinner isFetching={isReportsListFetching} />
      }
    </NormalLayoutContainer>
  )
}
